module.exports = __webpack_public_path__ + "static/staff-franco-52326fd2889423cc1c45659c4d3e712a.png";